<i class="fa-solid fa-user"></i><i class="fa-solid fa-left"></i>

<div class="button black">
  <div class="indigo">
    Share
  </div>
</div>
